export enum IdpStatus {
  Draft = 1,
  WithManager = 2,
  Acknowledged = 3,
  Completed = 4,
}

export interface IndividualDevelopmentPlan {
  id: string;
  employeeId: string;
  employeeName: string;
  departmentIds?: string[];
  departmentNames?: string[];
  managerId?: string;
  managerName?: string;
  year: number;
  careerAspirations: string; // Required
  status: IdpStatus;
  submittedAt?: string;
  approvedAt?: string;
  createdAt: string;
  updatedAt?: string;
  developmentGoals: DevelopmentGoal[];
  quarterlyReviews: IdpQuarterlyReview[];
}

export interface DevelopmentGoal {
  id: string;
  individualDevelopmentPlanId: string;
  skillOrCompetency: string;
  resourcesAndActivities: string;
  targetDeadline: string; // Required
  sequence: number;
}

export interface IdpQuarterlyReview {
  id: string;
  individualDevelopmentPlanId: string;
  reviewCycleId: string;
  reviewCycleName: string;
  reviewNumber: number;
  managerComments?: string;
  managerReviewDate?: string;
  employeeComments?: string;
  employeeReviewDate?: string;
  isCompleted: boolean;
}

export interface CreateIdpDto {
  year: number;
  careerAspirations?: string; // Optional on creation, required on save/submit
  developmentGoals: CreateDevelopmentGoalDto[]; // Optional on creation, at least one required on save/submit
}

export interface CreateDevelopmentGoalDto {
  skillOrCompetency: string;
  resourcesAndActivities: string;
  targetDeadline: string; // Required
  sequence: number;
}

export interface UpdateIdpDto {
  careerAspirations: string; // Required
  developmentGoals: UpdateDevelopmentGoalDto[]; // At least one required
}

export interface UpdateDevelopmentGoalDto {
  id?: string; // null for new goals
  skillOrCompetency: string;
  resourcesAndActivities: string;
  targetDeadline: string; // Required
  sequence: number;
}

export interface SubmitQuarterlyReviewDto {
  managerComments?: string;
  employeeComments?: string;
  /** Dates are set by the server when comments are submitted. */
}

/** Employee who has no IDP for the current year. Used for the "No IDP" filter on All IDPs page. */
export interface EmployeeWithoutIdp {
  employeeId: string;
  employeeName: string;
  employeeEmail?: string;
  departmentIds: string[];
  departmentNames: string[];
  managerId?: string;
  managerName?: string;
  year: number;
}

export interface IdpAuditEvent {
  id: string;
  eventType: IdpAuditEventType;
  actorId: string;
  actorName: string;
  eventAt: string;
  details?: string;
  metadata?: string;
}

export enum IdpAuditEventType {
  IdpCreated = 1,
  IdpSubmitted = 3,
  IdpAcknowledged = 4,
  QuarterlyReviewSubmitted = 9,
  IdpRevertedToDraftForReview = 10,
  IdpUpdated = 11,
  SupportingDocumentUploaded = 12,
  SupportingDocumentDeleted = 13,
  SupportingDocumentUpdated = 14,
}
